import { FC } from "react";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";

const VdpEdmundsTradeInTool: FC<IVDPPageBlock> = () => {
  return <div className="edmunds-trade-in" data-display="standard-trigger"></div>;
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <VdpEdmundsTradeInTool
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.LEFT,
};

export default VDPBlockData;
